import { render, staticRenderFns } from "./new-trainee.vue?vue&type=template&id=1526f763&scoped=true"
import script from "./new-trainee.vue?vue&type=script&lang=js"
export * from "./new-trainee.vue?vue&type=script&lang=js"
import style0 from "./new-trainee.vue?vue&type=style&index=0&id=1526f763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526f763",
  null
  
)

export default component.exports